import { render } from "./StudentAnalytics.vue?vue&type=template&id=14f849d2&scoped=true"
import script from "./StudentAnalytics.vue?vue&type=script&lang=js"
export * from "./StudentAnalytics.vue?vue&type=script&lang=js"

import "./StudentAnalytics.vue?vue&type=style&index=0&id=14f849d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f849d2"]])

export default __exports__